import { Injectable } from "@angular/core";
import { AppBaseService } from "./../services/http.service";
import { MICROSERVICES } from "../constants/web-services";

@Injectable({
  providedIn: "root"
})
export class ElasticService {
  constructor(private baseservice: AppBaseService) {}

  getElastic(objectName: string, text: string) {
    if (objectName != "" && text != "") {
      this.baseservice.setResourceURL(MICROSERVICES.AUDIT_SERVICE);
      return this.baseservice.getResource(
        "auditTrail/findRawTextByObjectName/" +
          objectName +
          "?input=" +
          text.toLowerCase()
      );
    }
  }
}
